import React,{useEffect,useState} from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import AddIcon from '@material-ui/icons/Add';
import {Inc,Story,ResultSet} from './Inc';
import Ajax from './Ajax';
import Login from './Login';
import Loading from './Loading';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './Top.scss';

interface Props {
    uid:string,
    isAuth:boolean,
    save(id?:string):void,
    move(str:string,param?:any):void,
}

const Top = (props:Props)=> {
    Ajax.setUid(props.uid);

    const defLatests:Story[] = [];
    const [states,setStates] = useState({
        latests:defLatests,
        isLoading:false,
    })
    const play = (event: React.MouseEvent<HTMLElement>)=>{
        if( !event.currentTarget.dataset.index ){
            return;
        }
        const index = parseInt(event.currentTarget.dataset.index);

        setStates({...states,isLoading:true});
        Ajax.send("play/add",{id:states.latests[index].id},(res:any)=>{
            if( res.ok ){
                const result:ResultSet = {
                    story: states.latests[index],
                    play: res.play,
                    is_suki: false,
                }
                if( res.uid && res.uid!=="" && res.uid!==props.uid ){
                    props.save(res.uid);
                }
                props.move("board",result);
            }
        })
    }
    const goEdit = ()=>{
        props.move("edit");
    }
    const goSearch = ()=>{
        props.move("search");
    }
    const login = (uid:string)=>{
        if( props.uid!=="" && props.uid!==uid ){
            Ajax.send("user/change",{new_uid:uid},(res:any)=>{
                if( res.ok ){
                    props.save(uid);        
                }
            });
        } else {
            props.save(uid);
        }
    }
    const logout = ()=>{
        props.save("");
    }
    
    useEffect( ()=>{
        Ajax.send("story/latest",{},(res:any)=>{
            //console.log(res);
            if( res.ok ){
                setStates({...states,"latests":res.latests});
            }
        });
    },[props.uid]);

    //console.log("top_render");

    let emptys:Story[] = [];
    for( let i=0 ; i<5-states.latests.length ; i++ ){
        emptys.push( Inc.defaultStory() );
    }

    return (
		<div id="top" className="root">
            <div className="title">
                よるのおてがみ
            </div>
            <div className="ver">
                ver.191005
            </div>
            <Grid container spacing={2}>
                {states.latests.map((latest:Story,index:number)=>{
                    const key = "latest"+index;
                    return (
                        <Grid item xs={6} key={key}>
                            <div className="menubox" onClick={play} data-index={index}>
                                {latest.title}
                                <span className="group">{Inc.groupNames[latest.group_id]}({latest.moji})</span>
                                <span className="suki"><FontAwesomeIcon icon="heart"/> {latest.suki}</span>
                            </div>
                        </Grid>
                    )
                })}
                {emptys.map((empty:Story,index:number)=>{
                    const key = "empty"+index;
                    return (
                        <Grid item xs={6} key={key}>
                            <div className="menubox disabled">
                                準備中
                            </div>
                        </Grid>
                    )
                })}
                <Grid item xs={6}>
                    <div className="menubox" onClick={goSearch}>
                        一覧
                        <span className="list">LIST</span>
                    </div>
                </Grid>
            </Grid>
            {!props.isAuth ? (
            <div className="loginBtns">
                <div style={{marginBottom:"0.5em"}}>おてがみを書くにはログインが必要です</div>
                <Login uid={props.uid} isAuth={false} login={login} logout={logout}/>
            </div>
            ):(
            <React.Fragment>
            <div className="nextBtns">
                <Button variant="contained" color="secondary" onClick={goEdit}><AddIcon/> おてがみをかく</Button>
            </div>
            <div className="loginBtns">
                <Login uid={props.uid} isAuth={true} login={login} logout={logout}/>
            </div>
            </React.Fragment>
            )}
            <div className="copyright">
                retro-ink 2019<br/>
                <a href="https://goisagi.retro-ink.com/" target="_blank" rel="noopener noreferrer">https://goisagi.retro-ink.com/</a><br/>
            </div>
            <Loading isLoading={states.isLoading}/>
		</div>
	);
}

export default Top;
